import API from './api';
import { handleApiError } from './utilsService';

// Servicio para las notificaciones
const notificationService = {
  // Obtener todas las notificaciones del usuario
  getNotifications: async (filters = {}) => {
    try {
      const response = await API.get('/notifications', { params: filters });
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al obtener las notificaciones');
    }
  },

  // Obtener una notificación por ID
  getNotificationById: async (id) => {
    try {
      const response = await API.get(`/notifications/${id}`);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al obtener la notificación');
    }
  },

  // Marcar una notificación como leída
  markAsRead: async (id) => {
    try {
      const response = await API.put(`/notifications/${id}/read`);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al marcar la notificación como leída');
    }
  },

  // Marcar todas las notificaciones como leídas
  markAllAsRead: async () => {
    try {
      const response = await API.put('/notifications/read-all');
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al marcar todas las notificaciones como leídas');
    }
  },

  // Eliminar una notificación
  deleteNotification: async (id) => {
    try {
      const response = await API.delete(`/notifications/${id}`);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al eliminar la notificación');
    }
  },

  // Eliminar todas las notificaciones
  deleteAllNotifications: async () => {
    try {
      const response = await API.delete('/notifications');
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al eliminar todas las notificaciones');
    }
  },

  // Obtener el número de notificaciones no leídas
  getUnreadCount: async () => {
    try {
      const response = await API.get('/notifications/unread-count');
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al obtener el número de notificaciones no leídas');
    }
  },

  // Enviar una notificación (solo admin)
  sendNotification: async (notificationData) => {
    try {
      const response = await API.post('/notifications/send', notificationData);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al enviar la notificación');
    }
  },

  // Enviar una notificación a todos los usuarios (solo admin)
  sendBroadcastNotification: async (notificationData) => {
    try {
      const response = await API.post('/notifications/broadcast', notificationData);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al enviar la notificación a todos los usuarios');
    }
  },

  // Actualizar las preferencias de notificaciones del usuario
  updateNotificationPreferences: async (preferences) => {
    try {
      const response = await API.put('/notifications/preferences', preferences);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al actualizar las preferencias de notificaciones');
    }
  },

  // Obtener las preferencias de notificaciones del usuario
  getNotificationPreferences: async () => {
    try {
      const response = await API.get('/notifications/preferences');
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al obtener las preferencias de notificaciones');
    }
  },

  // Registrar token de dispositivo para notificaciones push
  registerDeviceToken: async (deviceToken, deviceType) => {
    try {
      const response = await API.post('/notifications/devices', { deviceToken, deviceType });
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al registrar el token del dispositivo');
    }
  },

  // Eliminar token de dispositivo
  removeDeviceToken: async (deviceToken) => {
    try {
      const response = await API.delete(`/notifications/devices/${deviceToken}`);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al eliminar el token del dispositivo');
    }
  },

  // Enviar recordatorio masivo de jornada (solo admin)
  sendJornadaReminder: async (jornadaId, type) => {
    try {
      const response = await API.post('/notifications/jornada-reminder', {
        jornadaId,
        type
      });
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al enviar recordatorio de jornada');
    }
  },
};

export default notificationService;
